import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Slug from '../slug/slug';
import AdTagGenerator from '../video_module/utils/video_module_ads';
import Autoplay from '../video_module/utils/video_module_autoplay';
import log from '../../../services/logger_service';

let scriptjs = false;
let ifvisible = false;
if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
  // eslint-disable-next-line global-require
  ifvisible = require('ifvisible.js');
}

export default class Video extends Component {
  constructor() {
    super();

    this.state = {
      playingIndex: 0,
      activeTitle: '',
      userIsActive: true
    };

    // lookup for PERCENT INVIEW THRESHOLD for AUTOPLAY
    this.siteToPercentView = {
      fastcompany: 50,
      fastcodesign: 50
    };

    this.autoplay = null;
    this.setNextVideo = this.setNextVideo.bind(this);
    this.setMoatTracking = this.setMoatTracking.bind(this);
    this.setCaptions = this.setCaptions.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
  }

  componentDidMount() {
    if (scriptjs) {
      const { data, readTime } = this.props;
      let { playerid } = this.props;

      // When we're testing, use a dev specific video player so we can override adzone
      if (window && window.location.href.indexOf('adzone=qa') !== -1) {
        playerid = 'wip8TrhU';
      }

      scriptjs(
        [
          `//content.jwplatform.com/libraries/${playerid}.js`,
          'https://z.moatads.com/jwplayerplugin0938452/moatplugin.js'
        ],
        () => {
          if (!window.jwplayer) {
            log.error(
              `Error, no JWPlayer with playerID ${playerid} initialized`
            );
            return;
          }
          this.player = window.jwplayer('siderail-video-module__player');
          this.adTagGenerator = new AdTagGenerator(
            get(data, 'title'),
            this.props.type,
            'preroll_rightrail',
            readTime
          );

          // Set up activity tracker, 10s = idle
          if (ifvisible) {
            ifvisible.setIdleDuration(10);
            ifvisible.on('idle', () => {
              this.setState({
                userIsActive: false
              });
            });

            ifvisible.on('wakeup', () => {
              this.setState({
                userIsActive: true
              });
            });
          }
          this.initPlayer();
        }
      );
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const updateSettings = !this.state.settings;
    const updatePlayingIndex =
      this.state.playingIndex !== nextState.playingIndex;
    const updateActiveTitle = this.state.activeTitle !== nextState.activeTitle;

    return updateSettings || updatePlayingIndex || updateActiveTitle;
  }

  componentWillUnmount() {
    if (get(this, 'player.remove')) this.player.remove();
    if (this.autoplay !== null) this.autoplay.off();

    if (canUseDOM) {
      if (window.moatjw) {
        window.moatjw.removeAll();
      }
    }
  }

  setNextVideo() {
    const playingIndex = this.state.playingIndex + 1;
    this.setState({ playingIndex });
    if (this.state.userIsActive === false) {
      this.player.stop();
    }
  }

  setCaptions() {
    const caption = this.player.getMute() ? 1 : 0;
    this.autoplay.on();
    return this.player.setCurrentCaptions(caption);
  }

  setMoatTracking(event) {
    if (window.moatjw) {
      window.moatjw.add({
        partnerCode: 'mansuetojwint127635890115',
        player: this.player,
        adImpressionEvent: event
      });
    }
  }

  updateTitle(item) {
    this.setState({
      activeTitle: get(item, 'item.title')
    });
  }

  initPlayer() {
    // we will want to pass in playerid to ad tag
    const { config, playlistId } = this.props;

    const options = {
      playlist: `//content.jwplatform.com/feeds/${playlistId}.json`,
      autostart: false,
      sharing: {
        link: `https://www.${config.site}.com/video/share/MEDIAID`
      }
    };

    // example where homepage is setup https://dashboard.jwplayer.com/#/players/basic_setup?property=c08f27a0-75f3-11e6-8d4f-0a55b80e2f57&player_key=76APbejE
    options.advertising = {
      client: 'googima',
      tag: this.adTagGenerator.adTag,
      vpaidcontrols: true
    };

    this.player.setup(options);

    this.player.on('ready', () => {
      this.player.setMute(true);
      this.autoplay = new Autoplay({
        player: this.player,
        percentInView: this.siteToPercentView[
          get(config, 'site', 'fastcompany')
        ],
        playWhenOnTop: true
      });
      this.autoplay.on();
      this.player.on('playlistItem', this.updateTitle);
      this.player.on('play', this.setCaptions);
      this.player.on('displayClick', () => {
        // If user initiated pause, it should remove auto scroll play functionality for that session
        this.autoplay.off();
      });
      this.player.on('mute', this.setCaptions);
      this.player.on('adImpression', this.setMoatTracking);
      this.player.on('complete', this.setNextVideo);
      this.player.on('beforeComplete', () => {
        // To get video to stop autoadvancing, we have to somehow explicitly tell the player to stop listening to scroll event.
        // somehow this.autoplay.off() does NOT turn off the event listener, this is a temp fix.
        this.player.stop();
        this.autoplay.off();

        this.autoplay = null;
        this.autoplay = new Autoplay({
          player: this.player,
          percentInView: this.siteToPercentView[
            get(config, 'site', 'fastcompany')
          ],
          playWhenOnTop: true,
          dontPlay: true
        });

        this.autoplay.on();
      });
    });
  }

  render() {
    return (
      <div className="siderail-video-module">
        <Slug slugName={this.props.slugName} className="column" />
        <div className="siderail-video-module__player-container">
          <div id="siderail-video-module__player" />
        </div>
        <h3 className="card__title card__title--small siderail-video-module__player-title-slug">
          {this.state.activeTitle}
        </h3>
      </div>
    );
  }
}

Video.defaultProps = {
  data: {},
  slugName: 'Featured Video',
  readTime: null
};

Video.propTypes = {
  config: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({}),
  playerid: PropTypes.string.isRequired,
  playlistId: PropTypes.string.isRequired,
  slugName: PropTypes.string,
  type: PropTypes.string.isRequired,
  readTime: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/views/components/siderail_video_module/siderail_video_module.js